import { createAsyncThunk } from "@reduxjs/toolkit";
import getAxios from "../helpers/axiosInterceptor";
import { API_ROUTES_PATHS, BATCH_DETAILS_LIMIT } from "../utils/constant";

// Create Workflow
export const createWorkflow = createAsyncThunk(
  "workflow/createWorkflow",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(API_ROUTES_PATHS.WORKFLOW, model);
      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Get Workflow List
export const getWorkflowList = createAsyncThunk(
  "workflow/getWorkflowList",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(`${API_ROUTES_PATHS.WORKFLOW}`);

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Save Final Workflow
export const saveWorkFlow = createAsyncThunk(
  "workflow/saveWorkflow",
  async (model, thunkApi) => {
    try {
      const res = await getAxios().patch(
        `${API_ROUTES_PATHS.WORKFLOW}/${model.id}`,
        model
      );
      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Update Workflow
export const updateWorkflow = createAsyncThunk(
  "workflow/updateWorkflow",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().patch(
        `${API_ROUTES_PATHS.WORKFLOW}/${model.id}`,
        model
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Get Workflow By Id
export const getWorkflowById = createAsyncThunk(
  "workflow/getWorkflowById",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(`${API_ROUTES_PATHS.WORKFLOW}/${model}`);

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Delete Workflow By Id
export const deleteWorkflowById = createAsyncThunk(
  "workflow/deleteWorkflowById",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().delete(
        `${API_ROUTES_PATHS.WORKFLOW}/${model.id}`
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
// function to create Duplicate Workflow By Id
export const duplicateWorkflow = createAsyncThunk(
  "workflow/duplicateWorkflow",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(
        `${API_ROUTES_PATHS.WORKFLOW}/duplicate`,
        model
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
// function to create rename Workflow By Id
export const renameWorkflow = createAsyncThunk(
  "workflow/renameWorkflow",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().patch(
        `${API_ROUTES_PATHS.WORKFLOW}/rename`,
        model
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// function to search workflow/milestone/task/subTasks/outComes by name
export const searchWorkflowByName = createAsyncThunk(
  "workflow/searchWorkflow",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(
        `${API_ROUTES_PATHS.WORKFLOW}/search`,
        model
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Get Active Workflow
export const getActiveWorkflow = createAsyncThunk(
  "workflow/getActiveWorkflow",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(`${API_ROUTES_PATHS.WORKFLOW}`, {
        params: model?.query,
      });

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Get Workflow Mapping
export const getWorkflowMapping = createAsyncThunk(
  "workflow/getWorkflowMapping",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(
        `${API_ROUTES_PATHS.GET_WORKFLOW_MAPPING}/${model}`
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Create Workflow Configuration
export const createWorkflowConfiguration = createAsyncThunk(
  "workflow/createWorkflowConfiguration",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(
        `${API_ROUTES_PATHS.WORKFLOW_CONFIGURATION}`,
        model
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

// Get Workflow Configuration
export const getWorkflowConfiguration = createAsyncThunk(
  "workflow/getWorkflowConfiguration",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(
        `${API_ROUTES_PATHS.WORKFLOW_CONFIGURATION}`
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

export const getMappingStatus = createAsyncThunk(
  "Workflow/mappingStatus",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(`${API_ROUTES_PATHS.GET_MAPPING_STATUS}`);

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
export const fetchQueueProcessBatch = createAsyncThunk(
  "Workflow/mappingStatusById",
  async (model, thunkApi) => {
    try {
      const isObject = typeof model === "object" && model !== null;
      const batchId = isObject ? model?.batchId : model;
      const page = isObject ? model?.page : 1;
      const limit = isObject ? model?.limit : BATCH_DETAILS_LIMIT;
      let res = await getAxios().get(
        `${API_ROUTES_PATHS.GET_MAPPING_STATUS_BY_BATCHID}/${batchId}?page=${page}&limit=${limit}`
      );

      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

export const retryMappingBatch = createAsyncThunk(
  "workflow/retryMappingByBatchId",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().post(
        `${API_ROUTES_PATHS.MAPPING_RETRY_BY_BATCHID}/${model}/requeue`
      );
      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
export const fetchOutboxBatch = createAsyncThunk(
  "workflow/retryOutboxByBatchId",
  async (model, thunkApi) => {
    try {
      const isObject = typeof model === "object" && model !== null;
      const batchId = isObject ? model?.batchId : model;
      const page = isObject ? model?.page : 1;
      const limit = isObject ? model?.limit : BATCH_DETAILS_LIMIT;
      let res = await getAxios().get(
        `${API_ROUTES_PATHS.FETCH_OUTBOX_BATCH}/${batchId}?page=${page}&limit=${limit}`
      );
      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
export const retryOutboxMessage = createAsyncThunk(
  "workflow/retryOutboxByMessage",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(
        `${API_ROUTES_PATHS.OUTBOX_MESSAGE_RETRY}/${model}`
      );
      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
export const retryOutboxBatch = createAsyncThunk(
  "workflow/retryOutboxByBatch",
  async (model, thunkApi) => {
    try {
      let res = await getAxios().get(
        `${API_ROUTES_PATHS.OUTBOX_BATCH_RETRY}/${model}`
      );
      const responseData = res.data;
      return responseData;
    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);
